import {createFileRoute} from '@tanstack/react-router';
import {makeApiSortParam} from 'shared';
import {z} from 'zod';

import {userKeys} from '@/features/User/api/queryKeys';
import {getUsers} from '@/features/User/api/readUsers';
import {UserList} from '@/features/User/components/List/UserList';
import {DEFAULT_USER_TOP} from '@/features/User/utils/constants';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_company/users')({
  component: UserList,

  validateSearch: z.object({
    orderBy: z.string().optional(),
    filter: z.string().optional(),
    skip: z.number().catch(0),
  }),
  loaderDeps: ({search}) => ({...search}),

  beforeLoad: ({search, context}) => {
    makeDocumentTitle('Users');

    const _deps = {
      ...search,
      top: DEFAULT_USER_TOP,
      orderBy:
        search.orderBy ||
        makeApiSortParam([
          {prop: 'roleId', isAsc: true},
          {prop: 'name', isAsc: true},
        ]),
    };
    return {
      ...context,
      readUsersQuery: {
        queryKey: userKeys.list(_deps),
        queryFn: () => getUsers(_deps),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readUsersQuery);
  },
});
